module.exports = __webpack_public_path__ + "static/media/office.65c6812f.svg";